import { useCallback } from "react";
import type { LeadPipelineStage } from "api/crm-analytics";
import { PipelineCard, type PipelineStage } from "./PipelineCard";

const FALLBACK_SOURCE_COLOR = "#9CA3AF";

const LEAD_PIPELINE_HELP_TEXT =
  "The number in each stage represents how many leads moved into that stage within the selected period. For example, if Contacted shows 13, it means 13 Leads moved into the Contacted stage in the selected period.";

export type SourceColorMap = Map<number | null, string>;

export const LeadPipelineCard = ({
  data,
  isLoading,
  dateLabel,
  sourceColorMap,
  onStageClick
}: {
  data: LeadPipelineStage[] | undefined;
  isLoading: boolean;
  dateLabel: string;
  sourceColorMap: SourceColorMap;
  onStageClick?: (stage: LeadPipelineStage) => void;
}) => {
  const getSourceColor = useCallback(
    (sourceId: number | null) =>
      sourceColorMap.get(sourceId) ?? FALLBACK_SOURCE_COLOR,
    [sourceColorMap]
  );

  const getStageColor = useCallback(
    (_stage: PipelineStage) => FALLBACK_SOURCE_COLOR,
    []
  );

  return (
    <PipelineCard
      data={data}
      isLoading={isLoading}
      title="Lead pipeline"
      subtitle={`Lead stage progression – ${dateLabel}`}
      helpText={LEAD_PIPELINE_HELP_TEXT}
      variant="stacked"
      getStageColor={getStageColor}
      getSourceColor={getSourceColor}
      onStageClick={onStageClick}
    />
  );
};
